import { render, staticRenderFns } from "./project-weekly-add-or-update.vue?vue&type=template&id=0581b258&scoped=true&"
import script from "./project-weekly-add-or-update.vue?vue&type=script&lang=js&"
export * from "./project-weekly-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./project-weekly-add-or-update.vue?vue&type=style&index=0&id=0581b258&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0581b258",
  null
  
)

export default component.exports